import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IApiSageItemStringResponse } from '../../modules/graphql/types/types';

@Component({
  selector: 'app-sage-department-select-kendo',
  templateUrl: './sage-department-select-kendo.component.html',
  styleUrls: ['./sage-department-select-kendo.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SageDepartmentSelectKendoComponent),
      multi: true
    }
  ]
})
export class SageDepartmentSelectKendoComponent implements ControlValueAccessor {

  @Input() label = 'Sage Department';
  @Input() placeholder = 'Select Sage Department';
  @Input() departmentList: IApiSageItemStringResponse[] = [];

  public selectedId: string | null = null;

  constructor() { }

  public onValueChange(value: string | null): void {
    this.selectedId = value;
    this._propagateChange(this.selectedId);
    this._onTouched();
  }

  private _propagateChange = (_: any) => { };
  private _onTouched = () => { };

  public writeValue(value: any): void {
    this.selectedId = value ?? null;
  }

  public registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void { }
}
